import React, { useState } from 'react';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

import PropTypes from 'prop-types';
import { initializeApp } from 'firebase/app';
import { parseNearAmount } from 'near-api-js/lib/utils/format';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const firebaseConfig = {
  apiKey: 'AIzaSyA-vn6IaYVwmo0PU5S2OyuTBcCtWD5W7e4',
  authDomain: 'quizly-7d9f8.firebaseapp.com',
  projectId: 'quizly-7d9f8',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

// const half_Near = 1000000000;
// const one_Near = 1000000000000000000000000;

const CreateQuiz = ({ acc, save }) => {
  const answers = [];
  const encryption = async (trueHashed, questions) => {
    const auth = getAuth();
    await signInAnonymously(auth)
      .then(async () => {
        const encrypted = httpsCallable(functions, 'encrypt');
        await encrypted(trueHashed)
          .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            questions.map(
              (ans, index) => (questions[index].trueHashed = result.data[index])
            );
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const history = useNavigate();

  const [quizTitle, setQuizTitle] = useState('');
  const [quizDescription, setQuizDescription] = useState('');
  const [questions, setQuestions] = useState([
    {
      questionText: '',
      options: ['', ''],
      tags: [''],
      trueHashed: '',
      correctOption: '',
    },
  ]);

  // initiate as today's date
  const [availableFrom, setAvailableFrom] = useState(
    new Date().toISOString().split('T')[0]
  );
  // initiate as today's date + 3 days
  const [availableTill, setAvailableTill] = useState(
    new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split('T')[0]
  );
  const [allowMultipleTrials, setAllowMultipleTrials] = useState('');
  const [specificUsers, setSpecificUsers] = useState([]);
  const [rewardPerWinner, setRewardPerWinner] = useState('');
  const [winnerCount, setWinnerCount] = useState('');
  const [percentageToWin, setPercentageToWin] = useState('');
  const [giveRewards, setGiveRewards] = useState(true);

  const [optionsError, setOptionsError] = useState(false);

  const isFormFilled = () => {
    if (questions.length === 0) return false;

    if (percentageToWin < 40 || percentageToWin > 100) return false;

    if (giveRewards && rewardPerWinner < 0.1) return false;

    for (let i = 0; i < questions.length; i++) {
      if (questions[i].questionText === '') return false;

      for (let j = 0; j < questions[i].options.length; j++) {
        if (questions[i].options[j] === '') return false;
      }

      if (
        questions[i].trueHashed === '' ||
        questions[i].trueHashed === undefined
      )
        return false;

      if (questions[i].options.length === 0) return false;
    }

    return (
      quizTitle &&
      availableFrom &&
      availableTill &&
      allowMultipleTrials &&
      percentageToWin &&
      !optionsError &&
      (!giveRewards || (giveRewards && rewardPerWinner && winnerCount))
    );
  };

  const handleFormChange = (index, event, index1) => {
    let data = [...questions];
    if (event.target.name === 'trueHashed') {
      data[index][event.target.name] = event.target.value;
    } else if (event.target.name === 'correctAnswer') {
      data[index]['trueHashed'] = data[index]['options'][event.target.value];
      data[index]['correctOption'] = event.target.value;
    } else if (event.target.name === 'tags') {
      data[index][event.target.name] = event.target.value.split(',');
    } else if (event.target.name === 'options') {
      // loop through all options and check if any of them is duplicated
      data[index]['options'][index1] = event.target.value;
      let flag = false;
      for (let i = 0; i < data[index].options.length; i++) {
        for (let j = 0; j < data[index].options.length; j++) {
          if (i !== j && data[index].options[i] === data[index].options[j])
            flag = true;
        }
      }
      setOptionsError(flag);
      // update the trueHashed value
      data[index]['trueHashed'] =
        data[index]['options'][data[index]['correctOption']];
    } else {
      data[index][event.target.name] = event.target.value;
    }
    setQuestions(data);
  };

  const addFields = () => {
    let newField = {
      questionText: '',
      options: ['', ''],
      tags: [''],
      trueHashed: '',
    };
    setQuestions([...questions, newField]);
  };

  const addOption = (index) => {
    let data2 = [...questions];
    data2[index]['options'].push('');
    setQuestions(data2);
  };

  const [specificUsersList, setSpecificUsersList] = useState([]);

  useEffect(() => {
    // get transactionHashes from url
    const urlParams = new URLSearchParams(window.location.search);
    const transactionHashes = urlParams.get('transactionHashes');
    if (transactionHashes) {
      history('/profile');
    }
  }, []);

  useEffect(() => {
    const checkAcc = async (val) => {
      const ret = await window.walletConnection._near.account(val);
      return ret.state();
    };
    // if last character is a space, add it to the list
    if (specificUsers[specificUsers.length - 1] === ' ') {
      checkAcc(specificUsers.slice(0, -1))
        .then((res) => {
          if (res) {
            if (!specificUsersList.includes(specificUsers.slice(0, -1)))
              setSpecificUsersList([
                ...specificUsersList,
                specificUsers.slice(0, -1),
              ]);
            else
              toast.error(
                i18n.language === 'en'
                  ? 'User already added'
                  : 'المستخدم مضاف بالفعل'
              );
          }
        })
        .catch((err) => {
          toast.error(
            i18n.language === 'en'
              ? 'Invalid Account ID: ' + specificUsers.slice(0, -1)
              : 'معرف حساب غير صالح: ' + specificUsers.slice(0, -1)
          );
          // console.log(err);
        })
        .finally(() => {
          setSpecificUsers('');
        });
    }
  }, [specificUsers, specificUsersList]);

  const { t, i18n } = useTranslation();

  return (
    <main className='py-10 max-w-3xl mx-auto'>
      {acc.accountId ? (
        <>
          <h1 className='text-3xl font-semibold mb-7'>
            {t('create-quiz-title')}
          </h1>
          <form className='space-y-8 rounded bg-white bg-opacity-10 p-4'>
            <div className='relative z-0 w-full group mt-1'>
              <input
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                style={
                  i18n.language === 'ar'
                    ? {
                        textAlign: 'right',
                      }
                    : {}
                }
                type='text'
                name='floating_title'
                id='floating_title'
                className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                placeholder=' '
                value={quizTitle}
                onChange={(e) => setQuizTitle(e.target.value)}
              />
              <label
                style={
                  i18n.language === 'ar'
                    ? {
                        right: '0',
                        left: 'auto',
                      }
                    : {}
                }
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                htmlFor='floating_title'
                className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                {t('create-quiz-form-title')}
                <sup className='text-red-600'>*</sup>
              </label>
            </div>

            <div className='relative z-0 w-full group'>
              <input
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                type='text'
                name='floating_desc'
                id='floating_desc'
                className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                placeholder=' '
                value={quizDescription}
                onChange={(e) => setQuizDescription(e.target.value)}
              />
              <label
                style={
                  i18n.language === 'ar'
                    ? {
                        right: '0',
                        left: 'auto',
                      }
                    : {}
                }
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                htmlFor='floating_desc'
                className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                {t('create-quiz-form-desc')}
              </label>
            </div>

            <div
              className={`flex flex-col gap-4 w-full ${
                i18n.language === 'en' ? 'sm:flex-row' : ' sm:flex-row-reverse'
              }`}>
              <div className='relative z-0 w-full group'>
                <input
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  type='date'
                  name='floating_av_from'
                  id='floating_av_from'
                  style={{
                    colorScheme: window.localStorage.getItem('theme'),
                  }}
                  className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                  placeholder=' '
                  value={availableFrom}
                  onChange={(e) => {
                    setAvailableFrom(e.target.value);
                  }}
                />
                <label
                  style={
                    i18n.language === 'ar'
                      ? {
                          right: '-20px',
                          left: 'auto',
                        }
                      : {}
                  }
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  htmlFor='floating_av_from'
                  className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                  {t('create-quiz-form-date-from')}
                  <sup className='text-red-600'>*</sup>
                </label>
              </div>
              <div className='relative z-0 w-full group'>
                <input
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  type='date'
                  name='floating_av_till'
                  id='floating_av_till'
                  style={{
                    colorScheme: window.localStorage.getItem('theme'),
                  }}
                  className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                  placeholder=' '
                  value={availableTill}
                  onChange={(e) => {
                    // const d =
                    //   Math.floor(new Date(e.target.value).getTime()) * 1000000;
                    // setAvailableFrom(d.toString());
                    setAvailableTill(e.target.value);
                  }}
                />
                <label
                  style={
                    i18n.language === 'ar'
                      ? {
                          right: '-12px',
                          left: 'auto',
                        }
                      : {}
                  }
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  htmlFor='floating_av_till'
                  className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                  {t('create-quiz-form-date-till')}
                  <sup className='text-red-600'>*</sup>
                </label>
              </div>
              <div className='w-fit flex items-center justify-center'>
                <input
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  type='checkbox'
                  style={{
                    accentColor: '#e54a0a',
                  }}
                  className='w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
                  name='rewards'
                  id='rewards'
                  checked={giveRewards}
                  onChange={(e) => {
                    setGiveRewards(e.target.checked);
                    if (e.target.checked === false) {
                      setRewardPerWinner('0');
                      setWinnerCount(0);
                    }
                  }}
                />
                <label htmlFor='rewards' className='text-sm min-w-[12ch]'>
                  {t('create-quiz-form-give-rewards')}
                </label>
              </div>
            </div>
            <div
              className={`flex flex-col gap-4 w-full ${
                i18n.language === 'en' ? 'sm:flex-row' : ' sm:flex-row-reverse'
              }`}>
              <div className='relative z-0 w-full group'>
                <input
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  type='number'
                  name='floating_mul_trials'
                  id='floating_mul_trials'
                  className={
                    allowMultipleTrials === ''
                      ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                      : allowMultipleTrials >= 1
                      ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                      : 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-red-500 appearance-none dark:text-white dark:border-red-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                  }
                  placeholder=' '
                  value={allowMultipleTrials}
                  onChange={(e) =>
                    setAllowMultipleTrials(e.target.valueAsNumber)
                  }
                />
                <label
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  style={
                    i18n.language === 'ar'
                      ? {
                          right: '0',
                          left: 'auto',
                        }
                      : {}
                  }
                  htmlFor='floating_mul_trials'
                  className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                  {t('create-quiz-form-attempts')}{' '}
                  <sup className='text-red-600'>*</sup>
                </label>
              </div>
              <div className='relative z-0 w-full group'>
                <input
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  type='number'
                  name='floating_percentage'
                  id='floating_percentage'
                  className={
                    percentageToWin === ''
                      ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                      : percentageToWin >= 40 && percentageToWin <= 100
                      ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                      : 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-red-500 appearance-none dark:text-white dark:border-red-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                  }
                  placeholder=' '
                  value={percentageToWin}
                  onChange={(e) => setPercentageToWin(e.target.valueAsNumber)}
                />
                <label
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  style={
                    i18n.language === 'ar'
                      ? {
                          right: '0',
                          left: 'auto',
                        }
                      : {}
                  }
                  htmlFor='floating_percentage'
                  className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                  {t('create-quiz-form-percentage')}{' '}
                  <sup className='text-red-600'>*</sup>
                </label>
              </div>
            </div>

            {giveRewards && (
              <div
                className={`flex flex-col gap-4 w-full ${
                  i18n.language === 'en'
                    ? 'sm:flex-row'
                    : ' sm:flex-row-reverse'
                }`}>
                <div className='relative z-0 w-full group'>
                  <input
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    type='number'
                    name='floating_win_cnt'
                    id='floating_win_cnt'
                    className={
                      winnerCount === ''
                        ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        : winnerCount >= 1
                        ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        : 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-red-500 appearance-none dark:text-white dark:border-red-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                    }
                    placeholder=' '
                    value={winnerCount}
                    onChange={(e) => setWinnerCount(e.target.valueAsNumber)}
                  />
                  <label
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    style={
                      i18n.language === 'ar'
                        ? {
                            right: '0',
                            left: 'auto',
                          }
                        : {}
                    }
                    htmlFor='floating_win_cnt'
                    className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                    {t('create-quiz-form-number-winners')}{' '}
                    <sup className='text-red-600'>*</sup>
                  </label>
                </div>
                <div className='relative z-0 w-full group'>
                  <input
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    type='number'
                    name='floating_rwrd'
                    id='floating_rwrd'
                    className={
                      rewardPerWinner === ''
                        ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        : rewardPerWinner >= 1
                        ? 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        : 'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-red-500 appearance-none dark:text-white dark:border-red-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                    }
                    placeholder=' '
                    value={rewardPerWinner}
                    onChange={(e) => setRewardPerWinner(e.target.value)}
                  />
                  <label
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    style={
                      i18n.language === 'ar'
                        ? {
                            right: '0',
                            left: 'auto',
                          }
                        : {}
                    }
                    htmlFor='floating_rwrd'
                    className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                    {t('create-quiz-form-reward')}{' '}
                    <sup className='text-red-600'>*</sup>
                  </label>
                </div>
              </div>
            )}
            <div>
              <div className='relative z-0 w-full group'>
                <input
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  type='text'
                  name='floating_users'
                  id='floating_users'
                  className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                  placeholder=' '
                  value={specificUsers}
                  onChange={(e) => setSpecificUsers(e.target.value)}
                />
                <label
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  style={
                    i18n.language === 'ar'
                      ? {
                          right: '0',
                          left: 'auto',
                        }
                      : {}
                  }
                  htmlFor='floating_users'
                  className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                  {t('create-quiz-form-users')}
                </label>
              </div>
              {specificUsersList.length > 0 && (
                <div className='flex flex-wrap gap-2 mt-2'>
                  {specificUsersList.map(
                    (user) =>
                      user.length > 0 && (
                        <span
                          key={user}
                          className='rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex align-center cursor-pointer active:bg-gray-300 transition duration-300 ease w-max'>
                          <span className='flex items-center px-3 py-2'>
                            {user}
                          </span>
                          <button
                            className='bg-transparent hover focus:outline-none'
                            onClick={() => {
                              const newList = specificUsersList.filter(
                                (u) => u !== user
                              );
                              setSpecificUsersList(
                                newList.length > 0 ? newList : ['']
                              );
                            }}>
                            <svg
                              aria-hidden='true'
                              focusable='false'
                              className='w-3 mr-4'
                              role='img'
                              xmlns='http://www.w3.org/2000/svg'
                              viewBox='0 0 352 512'>
                              <path
                                fill='currentColor'
                                d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z'></path>
                            </svg>
                          </button>
                        </span>
                      )
                  )}
                </div>
              )}
            </div>

            <div className='space-y-6'>
              {questions.map((input, index) => {
                return (
                  <div
                    key={index}
                    className='px-4 py-3 rounded-lg shadow-md border-[2px] dark:border-slate-600 dark:shadow-none bg-white dark:bg-transparent space-y-2'>
                    <div
                      className={
                        i18n.language === 'ar'
                          ? 'flex flex-row-reverse items-center justify-between gap-2'
                          : 'flex items-center justify-between space-x-2'
                      }>
                      <h5 className='dark:text-slate-50 text-xl'>
                        {t('add-question-title')} {index + 1}
                      </h5>
                      {questions.length > 1 && (
                        <button
                          className='bg-red-700 p-1 rounded-full text-white'
                          onClick={(e) => {
                            e.preventDefault();
                            const newQuestions = questions.filter(
                              (q, i) => i !== index
                            );
                            let hasOptions = false;

                            input.options.forEach((o) => {
                              if (o.length > 0) {
                                hasOptions = true;
                              }
                            });

                            if (input.questionText.length > 0 || hasOptions) {
                              if (
                                window.confirm(
                                  i18n.language === 'en'
                                    ? 'Are you sure you wish to delete this question?'
                                    : 'هل أنت متأكد من أنك تريد حذف هذا السؤال؟'
                                ) === true
                              ) {
                                setQuestions(newQuestions);
                              }
                            } else {
                              setQuestions(newQuestions);
                            }
                          }}>
                          <svg
                            className='w-4 h-4'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                            xmlns='http://www.w3.org/2000/svg'>
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2.5'
                              d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'></path>
                          </svg>
                        </button>
                      )}
                    </div>
                    <div className='relative z-0 w-full group mb-3'>
                      <input
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        type='text'
                        name='questionText'
                        id='questionText'
                        className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        placeholder=' '
                        value={input.questionText}
                        onChange={(event) => handleFormChange(index, event, 0)}
                      />
                      <label
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        style={
                          i18n.language === 'ar'
                            ? {
                                right: '0',
                                left: 'auto',
                              }
                            : {}
                        }
                        htmlFor='questionText'
                        className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                        {t('add-question-title-ph')}{' '}
                        <sup className='text-red-600'>*</sup>
                      </label>
                    </div>

                    {/* <div className='relative z-0 w-full group'>
                      <input
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}

                        type='text'
                        name='tags'
                        id='tags'
                        className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        placeholder=' '
                        value={input.tags}
                        onChange={(event) => handleFormChange(index, event, 0)}
                      />
                      <label
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        style={
                          i18n.language === 'ar'
                            ? {
                                right: '0',
                                left: 'auto',
                              }
                            : {}
                        }
                        htmlFor='tags'
                        className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                        {t('add-question-tags-ph')}
                      </label>
                    </div> */}
                    <div className='space-y-2 mt-2'>
                      {input.options.map((inp, index1) => {
                        return (
                          <div
                            key={index1}
                            className={`flex items-center justify-center gap-2 ${
                              i18n.language === 'en'
                                ? 'flex-row'
                                : 'flex-row-reverse'
                            }`}>
                            <p className='font-mono'>{index1 + 1}</p>
                            <input
                              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                              style={
                                i18n.language === 'ar'
                                  ? {
                                      textAlign: 'right',
                                    }
                                  : {}
                              }
                              name='options'
                              placeholder={t('add-question-option')}
                              type='text'
                              value={inp}
                              className='border-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-inherit dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500'
                              onChange={(event) =>
                                handleFormChange(index, event, index1)
                              }
                            />
                            {input.options.length > 2 && (
                              <button
                                className='bg-red-700 p-1 rounded-full text-white'
                                onClick={(e) => {
                                  e.preventDefault();
                                  const newOptions = input.options.filter(
                                    (option, index2) => index2 !== index1
                                  );
                                  // const newList = input.options.filter(
                                  //   (u) => u !== inp
                                  // );
                                  const newInput = {
                                    ...input,
                                    options: newOptions,
                                  };
                                  if (newInput.options.length === 0) {
                                    newInput.options.push('');
                                  }
                                  if (inp.length > 0) {
                                    if (
                                      window.confirm(
                                        i18n.language === 'en'
                                          ? 'Are you sure you wish to delete this option?'
                                          : 'هل أنت متأكد من أنك تريد حذف هذا الخيار؟'
                                      )
                                    ) {
                                      setQuestions((prev) => {
                                        const newQuestions = [...prev];
                                        newQuestions[index] = newInput;
                                        return newQuestions;
                                      });
                                    }
                                  } else
                                    setQuestions((prev) => {
                                      const newQuestions = [...prev];
                                      newQuestions[index] = newInput;
                                      return newQuestions;
                                    });
                                }}>
                                <svg
                                  className='w-4 h-4'
                                  fill='none'
                                  stroke='currentColor'
                                  viewBox='0 0 24 24'
                                  xmlns='http://www.w3.org/2000/svg'>
                                  <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth='2.5'
                                    d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'></path>
                                </svg>
                              </button>
                            )}
                          </div>
                        );
                      })}
                      <p className='text-primary-400'>
                        {optionsError && t('create-quiz-options-error')}
                      </p>
                      <button
                        className='text-white bg-lime-700 hover:bg-lime-800 focus:ring-4 focus:ring-lime-300 font-medium rounded-lg text-sm px-3 py-1.5 dark:bg-lime-600 dark:hover:bg-lime-700 focus:outline-none dark:focus:ring-lime-800'
                        onClick={(e) => {
                          e.preventDefault();
                          addOption(index);
                        }}>
                        {t('add-question-add-option-ph')}
                      </button>
                    </div>

                    <div className='relative z-0 w-full group mt-3'>
                      <select
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        type='text'
                        name='correctAnswer'
                        id='correctAnswer'
                        className='block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary-500 focus:outline-none focus:ring-0 focus:border-primary-600 peer'
                        placeholder=' '
                        value={input.correctOption}
                        onChange={(event) => handleFormChange(index, event, 0)}>
                        <option value>-- select the correct answer --</option>
                        {input.options.map((op, index) => {
                          return (
                            <option
                              key={index}
                              value={index}
                              // className='text-gray-900 dark:text-white'
                            >
                              {index + 1}
                            </option>
                          );
                        })}
                      </select>
                      <label
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        style={
                          i18n.language === 'ar'
                            ? {
                                right: '0',
                                left: 'auto',
                              }
                            : {}
                        }
                        htmlFor='trueHashed'
                        className='peer-focus:font-medium absolute left-0 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6'>
                        {t('add-question-correct-answer')}
                        <sup className='text-red-600'>*</sup>
                      </label>
                    </div>
                  </div>
                );
              })}
            </div>
            <button
              className={`inline-flex items-center justify-center gap-2 text-white bg-lime-700 hover:bg-lime-800 focus:ring-4 focus:ring-lime-300 font-medium rounded-lg px-4 py-2 dark:bg-lime-600 dark:hover:bg-lime-700 focus:outline-none dark:focus:ring-lime-800 ${
                i18n.language === 'en' ? 'flex-row' : 'flex-row-reverse'
              }`}
              onClick={(e) => {
                e.preventDefault();
                addFields();
              }}>
              {t('add-question-add-more')}
              <svg
                className='w-5 h-5'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M12 6v6m0 0v6m0-6h6m-6 0H6'></path>
              </svg>
            </button>
          </form>

          <button
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            className='mt-6 text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg  px-5 py-2.5 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary-700 disabled:dark:hover:bg-primary-600'
            disabled={!isFormFilled()}
            onClick={() => {
              const avFrom = (
                Math.floor(new Date(availableFrom).getTime()) * 1000000
              ).toString();
              const avTill = (
                Math.floor(new Date(availableTill).getTime()) * 1000000
              ).toString();

              // Error handling
              const today = new Date().toISOString().slice(0, 10);
              const todayInMs = Math.floor(new Date(today).getTime()) * 1000000;

              if (avFrom > avTill) {
                toast.error(
                  i18n.language === 'ar'
                    ? 'تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء'
                    : 'Available from cannot be greater than available till'
                );
                return;
              }
              if (avFrom < todayInMs) {
                toast.error(
                  i18n.language === 'ar'
                    ? 'تاريخ البدء يجب أن يكون بعد اليوم'
                    : 'Available from cannot be less than today'
                );
                return;
              }
              if (avTill < todayInMs) {
                toast.error(
                  i18n.language === 'ar'
                    ? 'تاريخ الانتهاء يجب أن يكون بعد اليوم'
                    : 'Available till cannot be less than today'
                );
                return;
              }

              const parsedReward = parseNearAmount(rewardPerWinner);
              questions.map((question) => answers.push(question.trueHashed));
              console.log(questions);
              encryption(answers, questions).then((r) =>
                save(
                  {
                    quizTitle,
                    quizDescription,
                    questions,
                    specificUsers: specificUsersList,
                    availableFrom: avFrom,
                    availableTill: avTill,
                    allowMultipleTrials,
                    rewardPerWinner: parsedReward,
                    winnerCount,
                    percentageToWin,
                  },
                  giveRewards
                    ? parseNearAmount(
                        (rewardPerWinner * winnerCount + 1).toString()
                      )
                    : parseNearAmount('1')
                )
              );
            }}>
            {t('create-quiz-form-button')} (
            {giveRewards
              ? (rewardPerWinner ? rewardPerWinner : 0) *
                  (winnerCount ? winnerCount : 0) +
                1
              : 1}{' '}
            NEAR)
          </button>
        </>
      ) : (
        <div className='min-h-[67vh] grid items-center'>
          You can't access this page without logging in
        </div>
      )}
    </main>
  );
};

CreateQuiz.propTypes = {
  save: PropTypes.func.isRequired,
};

export default CreateQuiz;
